export enum DeviceSecurityMode {
  NONE = "NONE",
  SIGN = "SIGN",
  SIGN_AND_ENCRYPT = "SIGN_AND_ENCRYPT",
}

export const deviceSecurityModes = Object.values(DeviceSecurityMode);